<template>
  <svg :class="[iconStyle, 'icon']" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: "icon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    iconStyle: String,
  },
  computed: {
    iconName() {
      let val = "";
      if (this.iconClass) {
        if (this.iconClass.includes("icon-")) {
          val = `#${this.iconClass}`
        } else {
          val = `#icon-${this.iconClass}`;
        }
      }
      return val;
    },
  },
};
</script>
<style scoped>
.icon {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
  margin-right: 10px;
}
</style>
